import React from 'react';
import { useAsset } from '../hooks/useAsset';

const TableBackground: React.FC<{ isDay?: boolean }> = ({ isDay = true }) => {
  const bgA = useAsset('ui.table.bgA');
  const bgB = useAsset('ui.table.bgB');
  return (
    <div className="fixed inset-0 -z-10">
      <img src={bgA} alt="table layer A" className="absolute inset-0 w-full h-full object-cover" style={{ opacity: isDay ? 1 : 0 }} />
      <img src={bgB} alt="table layer B" className="absolute inset-0 w-full h-full object-cover" style={{ opacity: isDay ? 0 : 1 }} />
    </div>
  );
};

export default TableBackground;
